import './blockchain-explorer-button.scss';
import { SearchIcon } from 'assets/icons';
import { IconBtn } from '@ru-digital-assets/ui-component';
import React from 'react';


interface IBlockchainExplorerButton {
  trxnId?: string;
}

export default function BlockchainExplorerButton({
  trxnId
}: IBlockchainExplorerButton) {
  return (
    <IconBtn
      title="Посмотреть транзакцию в блокчейн Explorer"
      outlined
      icon={<SearchIcon />}
      onClick={() => {
        window!.open(`https://explorer.cfa.digital/tx/${trxnId}`, '_blank')!.focus();
      }}
    />
  );
}
